import MeasurementCard from "../../components/MeasurementCard/MeasurementCard";
import './Recordings.css';

export default function Recordings(){
    return(
    <>
      <MeasurementCard />
    </>
    )
}

